<template>
	<div class="kzq-view-container">
		<!-- 设备基础信息卡片：改造为深蓝调，布局规整 -->
		<el-row class="device-info-card">
			<el-row class="info-content">
				<el-col :span="11" class="info-left">
					<el-row class="device-img-box">
						<img :src="formObject.picUrl" :alt="formObject.deviceName" class="device-img"/>
					</el-row>
				</el-col>
				<el-col :span="13" class="info-right">
					<el-row class="device-name">{{formObject.deviceName}}</el-row>
					<el-row class="info-item">
						<el-col class="info-label">状态：</el-col>
						<el-col class="info-value">
							<label class="status-offline" v-if="formObject.deviceStatus == 1">离线</label>
							<label class="status-online" v-if="formObject.deviceStatus == 2">在线</label>
						</el-col>
					</el-row>
					<el-row class="info-item">
						<el-col class="info-label">设备种类：</el-col>
						<el-col class="info-value">
							<label v-if="formObject.deviceType == 1">控制器</label>
						  <label v-if="formObject.deviceType == 2">电表</label>
						  <label v-if="formObject.deviceType == 3">逆变器</label>
						</el-col>
					</el-row>
					<el-row class="info-item" :title="formObject.address">
						<el-col class="info-label">设备地址：</el-col>
						<el-col class="info-value" v-if="formObject.address">
							{{formObject.address}}
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</el-row>

		<!-- 标签导航栏+操作按钮：改造样式，与系统统一 -->
		<el-row class="tab-nav-bar">
			<div class="tab-container">
				<el-row class="tab-list">
					<el-col 
						v-for="(item,index) in optMenus" 
						:key="index"
						:class="selectIndex==index?'tab-item active':'tab-item'"
						@click.native="selectIndex = index;changeTyoe();"
					>
						{{item}}
					</el-col>
				</el-row>
				<!-- 编辑操作按钮：仅充电参数标签显示 -->
				<div class="btn-group" v-if="selectIndex == 2">
					<el-button 
						type="primary" 
						icon="el-icon-edit" 
						class="operate-btn"
						round 
						@click="doEdity();" 
						v-if="!isEdit && canEdit === 1"
					>编辑参数</el-button>
					
					<el-button 
						type="danger" 
						icon="el-icon-delete" 
						class="operate-btn"
						round 
						@click="isEdit = false;" 
						v-if="isEdit"
					>取消编辑</el-button>
					
					<el-button 
						type="primary" 
						icon="el-icon-check" 
						class="operate-btn"
						round 
						v-if="isEdit" 
						@click="subEditForm()"
					>提交修改</el-button>
				</div>
			</div>
		</el-row>

		<!-- 实时数据标签：保留原展示结构，改造为深蓝调 -->
		<el-row class="data-card" v-if="selectIndex == 0">
			<el-row class="data-row">
				<!-- 工作状态 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">工作状态</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">MPPT充电</div>
				</div>
				<!-- 光伏输入电压1 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">光伏输入电压1</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.pvInVolCh1}}V</div>
				</div>
				<!-- 光伏输入电压2 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">光伏输入电压2</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.pvInVolCh2}}V</div>
				</div>
				<!-- 光伏输入电压3 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">光伏输入电压3</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.pvInVolCh3}}V</div>
				</div>
			</el-row>

			<el-row class="data-row">
				<!-- 光伏输入电压4 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">光伏输入电压4</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.pvInVolCh4}}V</div>
				</div>
				<!-- 模组1输出电流 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">模组1输出电流</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.pvOutCurCh1}}A</div>
				</div>
				<!-- 模组2输出电流 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">模组2输出电流</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.pvOutCurCh2}}A</div>
				</div>
				<!-- 模组3输出电流 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">模组3输出电流</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.pvOutCurCh3}}A</div>
				</div>
			</el-row>

			<el-row class="data-row">
				<!-- 模组4输出电流 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">模组4输出电流</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.pvOutCurCh4}}A</div>
				</div>
				<!-- 输出电压 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">输出电压</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.pvOutVol}}V</div>
				</div>
				<!-- 输出总电流 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">输出总电流</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.pvOutCurTotal}}A</div>
				</div>
				<!-- 输出总功率 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">输出总功率</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.pvOutPowerTotal}}KW</div>
				</div>
			</el-row>

			<el-row class="data-row">
				<!-- 输出总电压 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">输出总电压</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.pvOutVolTotal}}V</div>
				</div>
				<!-- 负载电压 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">负载电压</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.loadVol}}V</div>
				</div>
				<!-- 负载电流 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">负载电流</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.loadcur}}A</div>
				</div>
				<!-- 负载功率 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">负载功率</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.loadPower}}KW</div>
				</div>
			</el-row>

			<el-row class="data-row">
				<!-- 电池温度 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">电池温度</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.tempBat}}℃</div>
				</div>
				<!-- 内部温度 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">内部温度</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.tempInternal}}℃</div>
				</div>
				<!-- CO2减排 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">CO2减排</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.co2}}KG</div>
				</div>
				<!-- 故障代码 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">故障代码</div>
						<div class="item-time">{{formData.uploadTime}}</div>
					</div>
					<div class="item-value">{{formData.errcode}}</div>
				</div>
			</el-row>
		</el-row>

		<!-- 运行数据标签：保留原展示结构，改造为深蓝调 -->
		<el-row class="data-card" v-if="selectIndex == 1">
			<el-row class="data-row">
				<!-- 模组数量 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">模组数量</div>
						<div class="item-time">{{yunXingData.uploadTime}}</div>
					</div>
					<div class="item-value">{{yunXingData.mozuNum}}个</div>
				</div>
				<!-- 电池容量 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">电池容量</div>
						<div class="item-time">{{yunXingData.uploadTime}}</div>
					</div>
					<div class="item-value">{{yunXingData.dianciTotal}}</div>
				</div>
				<!-- 设备地址 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">设备地址</div>
						<div class="item-time">{{yunXingData.uploadTime}}</div>
					</div>
					<div class="item-value">{{yunXingData.address}}</div>
				</div>
				<!-- 日发电量 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">日发电量</div>
						<div class="item-time">{{yunXingData.uploadTime}}</div>
					</div>
					<div class="item-value">{{yunXingData.dayNum}}kWh</div>
				</div>
			</el-row>

			<el-row class="data-row">
				<!-- 月发电量 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">月发电量</div>
						<div class="item-time">{{yunXingData.uploadTime}}</div>
					</div>
					<div class="item-value">{{yunXingData.monthNum}}kWh</div>
				</div>
			</el-row>
		</el-row>

		<!-- 充电参数标签：保留编辑/展示切换，改造为深蓝调 -->
		<el-row class="data-card" v-if="selectIndex == 2">
			<el-row class="data-row">
				<!-- 均充电压 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">均充电压</div>
						<div class="item-time">{{chongDianData.uploadTime}}</div>
					</div>
					<div class="item-value" v-if="!isEdit">
						{{chongDianData.bcdy}}V
					</div>
					<el-input 
						placeholder="请输入均充电压" 
						v-model="editForm.bcdy" 
						class="edit-input" 
						v-if="isEdit"
					>
					    <template slot="append">V</template>
					</el-input>
				</div>
				<!-- 浮充电压 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">浮充电压</div>
						<div class="item-time">{{chongDianData.uploadTime}}</div>
					</div>
					<div class="item-value" v-if="!isEdit">
						{{chongDianData.gfdy}}V
					</div>
					<el-input 
						placeholder="请输入浮充电压" 
						v-model="editForm.gfdy" 
						class="edit-input" 
						v-if="isEdit"
					>
						<template slot="append">V</template>
					</el-input>
				</div>
				<!-- 低压保护 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">低压保护</div>
						<div class="item-time">{{chongDianData.uploadTime}}</div>
					</div>
					<div class="item-value" v-if="!isEdit">
						{{chongDianData.cddy}}V
					</div>
					<el-input 
						placeholder="请输入低压保护值" 
						v-model="editForm.cddy" 
						class="edit-input" 
						v-if="isEdit"
					>
						<template slot="append">V</template>
					</el-input>
				</div>
				<!-- 低压恢复 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">低压恢复</div>
						<div class="item-time">{{chongDianData.uploadTime}}</div>
					</div>
					<div class="item-value" v-if="!isEdit">
						{{chongDianData.dyhfdy}}V
					</div>
					<el-input 
						placeholder="请输入低压恢复值" 
						v-model="editForm.dyhfdy" 
						class="edit-input" 
						v-if="isEdit"
					>
						<template slot="append">V</template>
					</el-input>
				</div>
			</el-row>

			<el-row class="data-row">
				<!-- 过充恢复 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">过充恢复</div>
						<div class="item-time">{{chongDianData.uploadTime}}</div>
					</div>
					<div class="item-value" v-if="!isEdit">
						{{chongDianData.gchfdy}}V
					</div>
					<el-input 
						placeholder="请输入过充恢复值" 
						v-model="editForm.gchfdy" 
						class="edit-input" 
						v-if="isEdit"
					>
						<template slot="append">V</template>
					</el-input>
				</div>
				<!-- 过充电压 -->
				<div class="data-item">
					<div class="item-header">
						<div class="item-title">过充电压</div>
						<div class="item-time">{{chongDianData.uploadTime}}</div>
					</div>
					<div class="item-value" v-if="!isEdit">
						{{chongDianData.gcdy}}V
					</div>
					<el-input 
						placeholder="请输入过充电压值" 
						v-model="editForm.gcdy" 
						class="edit-input" 
						v-if="isEdit"
					>
						<template slot="append">V</template>
					</el-input>
				</div>
			</el-row>
		</el-row>
	</div>
</template>

<script>
	import { getAccountPermission } from '../../utils/accountPermission';

	export default {
		name: 'deviceKzqView',
		props: {
		  id: {
		    required: false,
		    type: Number
		  }
		},
	    data() {
		  return {
			  canEdit:1,
			  editForm:{},        // 编辑表单数据
			  isEdit:false,       // 是否编辑状态
			  chongDianData:{},   // 充电参数数据
			  yunXingData:{},     // 运行数据
			  formData:{},        // 实时数据
			  optMenus:["实时数据","运行数据","充电参数"], // 标签菜单
			  selectIndex:0,      // 当前选中标签索引
			  formObject:{}       // 设备基础信息
		  }
		},
		mounted() {
			this.canEdit = getAccountPermission();
			// 加载设备基础信息+初始化标签数据
			this.infoView(this.id);
			this.changeTyoe();
		},
		methods:{
			// 进入编辑状态，赋值表单
			doEdity(){
				this.editForm = {
					'bcdy':this.chongDianData.bcdy,
					'gfdy':this.chongDianData.gfdy,
					'cddy':this.chongDianData.cddy,
					'dyhfdy':this.chongDianData.dyhfdy,
					'gchfdy':this.chongDianData.gchfdy,
					'gcdy':this.chongDianData.gcdy,
					'imei':this.formObject.serNo
				};
				this.isEdit = true;
			},
			// 提交修改参数
			subEditForm(){
				this.$request.post("/api/device/set/instruction",this.editForm).then(response =>{
					this.$Message.success(response.data.message);
					this.isEdit = false; // 提交后退出编辑状态
					this.loadCdData();   // 刷新充电参数数据
				}).catch(err => {
					this.$Message.error("提交失败，请联系管理员！");
				})
			},
			// 切换标签加载对应数据
			changeTyoe(){
				if(this.selectIndex == 0){
					this.loadData(); // 实时数据
				}else if(this.selectIndex == 1){
					this.loadYunXingData(); // 运行数据
				}else{
					this.loadCdData(); // 充电参数
				}
			},
			// 加载充电参数数据
			loadCdData(){
				let query = {deviceType:1,id:this.id,pageNum:1,pageSize:1}
				this.$request.post("/api/device/gf/cd/page",query).then(response =>{
					if(response.data.result&&response.data.data!=null){
						this.chongDianData = response.data.data.list[0];
					}else{
						this.$Message.error("获取充电参数失败,请联系管理员!");
					}
				}).catch(err => {
					this.$Message.error("网络异常，获取充电参数失败！");
				})
			},
			// 加载运行数据
			loadYunXingData(){
				let query = {deviceType:1,id:this.id,pageNum:1,pageSize:1}
				this.$request.post("/api/device/gf/online/page",query).then(response =>{
					if(response.data.result&&response.data.data!=null){
						this.yunXingData = response.data.data.list[0];
					}else{
						this.$Message.error("获取运行数据失败,请联系管理员!");
					}
				}).catch(err => {
					this.$Message.error("网络异常，获取运行数据失败！");
				})
			},
			// 加载实时数据
			loadData(){
				let query = {deviceType:1,id:this.id,pageNum:1,pageSize:1}
				this.$request.post("/api/device/gf/last/page",query).then(response =>{
					if(response.data.result&&response.data.data!=null){
						this.formData = response.data.data.list[0];
					}else{
						this.$Message.error("获取实时数据失败,请联系管理员!");
					}
				}).catch(err => {
					this.$Message.error("网络异常，获取实时数据失败！");
				})
			},
			// 加载设备基础详情数据
			infoView(id){
				this.$request.get('/api/device/info/'+id).then(response => {
					if(response.data.result){
						this.formObject = response.data.data;
					}else{
						this.$Message.error("获取设备信息失败,请联系管理员!");
					}
				}).catch(err => {
					this.$Message.error("网络异常，获取设备信息失败！");
				})	
			}
		}
	}
</script>

<style scoped>
	/* 页面整体容器 */
	.kzq-view-container {
		width: 100%;
		height: 100%;
		padding: 0 8px;
		box-sizing: border-box;
	}

	/* 设备基础信息卡片 */
	.device-info-card {
		width: 100%;
		height: 124px;
		border: 1px solid rgba(var(--solar-border-strong-rgb, 0, 153, 255), 0.42);
		border-radius: 8px;
		background: linear-gradient(90deg, rgba(var(--solar-raised-rgb, 0, 52, 88), 0.94), rgba(var(--solar-page-rgb, 0, 35, 63), 0.82));
		box-shadow: inset 0 1px 0 rgba(176, 226, 255, 0.08);
		margin-bottom: 10px;
		overflow: hidden;
	}
	.info-content {
		width: 100%;
		height: 100%;
		padding: 16px 18px;
		display: flex;
		align-items: center;
		gap: 20px;
		box-sizing: border-box;
	}
	.info-left {
		width: 132px !important;
		flex: 0 0 132px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.device-img-box {
		width: 132px;
		height: 90px;
		border: 1px solid rgba(135, 206, 250, 0.26);
		border-radius: 6px;
		overflow: hidden;
		background: rgba(var(--solar-page-rgb, 0, 18, 36), 0.48);
	}
	.device-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.info-right {
		width: auto !important;
		min-width: 0;
		flex: 1 1 auto;
		color: var(--solar-text, #87CEFA);
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		grid-template-rows: 28px 44px;
		gap: 8px 12px;
	}
	.device-name {
		grid-column: 1 / -1;
		font-size: 18px;
		line-height: 28px;
		font-weight: 900;
		color: var(--solar-text-strong, #dff8ff);
	}
	.info-item {
		min-width: 0;
		height: 44px;
		display: flex;
		align-items: center;
		padding: 0 12px;
		border: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.2);
		border-radius: 6px;
		background: rgba(var(--solar-page-rgb, 0, 26, 51), 0.5);
		box-sizing: border-box;
	}
	.info-label {
		width: auto;
		flex: 0 0 auto;
		margin-right: 6px;
		color: var(--solar-text, #87CEFA);
	}
	.info-value {
		width: auto;
		min-width: 0;
		flex: 1 1 auto;
		color: var(--solar-text-strong, #fff);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	/* 设备状态颜色 */
	.status-offline { color: var(--solar-danger, #FF6666); }
	.status-online { color: var(--solar-primary, #00CCFF); }

	/* 标签导航栏 */
	.tab-nav-bar {
		border-top: 0;
		margin-top: 0;
		padding: 0 0 8px;
	}
	.tab-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 0 6px;
		width: calc(100% - 12px);
	}
	.tab-list {
		display: flex;
		align-items: center;
	}
	.tab-item {
		width: 120px;
		height: 36px;
		line-height: 36px;
		text-align: center;
		border-radius: 8px;
		margin-left: 10px;
		cursor: pointer;
		transition: all 0.3s ease;
		background-color: var(--solar-surface, #002B4D);
		border: 1px solid var(--solar-border, #003C66);
		color: var(--solar-text, #87CEFA);
	}
	.tab-item:first-child {
		margin-left: 0;
	}
	.tab-item.active {
		background-color: var(--solar-primary, #0099FF);
		color: var(--solar-text-strong, #fff);
		border: none;
	}
	.tab-item:hover:not(.active) {
		background-color: var(--solar-raised, #003C66);
		border-color: var(--solar-border-strong, #0099FF);
		color: var(--solar-text-strong, #B0E2FF);
	}
	/* 操作按钮组 */
	.btn-group {
		display: flex;
		align-items: center;
		gap: 12px;
		margin-top: 4px;
	}
	.operate-btn {
		width: 120px;
		height: 38px;
		background-color: var(--solar-primary, #0099FF) !important;
		border: none !important;
	}
	:deep(.operate-btn.el-button--danger) {
		background-color: #FF6666 !important;
	}

	/* 数据展示卡片通用样式 */
	.data-card {
		border: 1px solid var(--solar-border, #003C66);
		border-radius: 8px;
		margin-top: 0;
		padding: 5px 0;
		background-color: var(--solar-surface, #002B4D);
	}
	/* 数据行：4列布局 */
	.data-row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		margin: 3px 0;
	}
	/* 数据项卡片 */
	.data-item {
		width: calc((100% - 53px)/4);
		height: 94px;
		border: 1px solid var(--solar-border, #003C66);
		border-radius: 8px;
		margin-left: 12px;
		background-color: var(--solar-page, #001A33);
		padding: 6px;
		box-sizing: border-box;
		transition: all 0.3s ease;
	}
	.data-item:hover {
		box-shadow: 0 0 8px rgba(var(--solar-primary-rgb, 0, 153, 255), 0.3);
		border-color: var(--solar-border-strong, #0099FF);
	}
	/* 数据项头部：标题+时间 */
	.item-header {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 6px;
		margin: 2px 6px 0;
	}
	.item-title {
		min-width: 0;
		font-weight: 900;
		font-size: 13px;
		line-height: 18px;
		color: var(--solar-text-strong, #B0E2FF);
	}
	.item-time {
		max-width: 58%;
		flex: 0 1 auto;
		font-size: 11px;
		line-height: 18px;
		color: var(--solar-muted, #6699CC);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	/* 数据项值：大字体展示 */
	.item-value {
		font-size: 24px;
		line-height: 30px;
		font-weight: bolder;
		color: var(--solar-text, #87CEFA);
		text-align: center;
		margin-top: 14px;
	}
	/* 编辑状态输入框 */
	.edit-input {
		width: calc(100% - 12px);
		margin: 12px 6px 0;
	}
	:deep(.edit-input .el-input__inner) {
		background-color: var(--solar-page, #001A33) !important;
		border: 1px solid var(--solar-border-strong, #0099FF) !important;
		color: var(--solar-text, #87CEFA) !important;
		font-size: 18px;
		text-align: center;
	}
	:deep(.edit-input .el-input__append) {
		color: var(--solar-text, #87CEFA) !important;
		background-color: var(--solar-surface, #002B4D) !important;
		border-left: 1px solid var(--solar-border-strong, #0099FF) !important;
	}

	/* 滚动条样式：与系统统一 */
	:deep(::-webkit-scrollbar) {
		width: 6px;
		height: 6px;
		background-color: var(--solar-page, #001A33);
	}
	:deep(::-webkit-scrollbar-thumb) {
		background-color: var(--solar-primary, #0099FF);
		border-radius: 3px;
	}
	:deep(::-webkit-scrollbar-track) {
		background-color: var(--solar-surface, #002B4D);
		border-radius: 3px;
	}

	@media (max-width: 760px) {
		.kzq-view-container {
			height: auto;
			padding: 0;
		}

		.device-info-card {
			height: auto;
			margin-bottom: 12px;
			overflow: visible;
		}

		.info-content {
			height: auto;
			align-items: stretch;
			gap: 12px;
			padding: 12px;
		}

		.info-left {
			width: 116px !important;
			flex-basis: 116px;
		}

		.device-img-box {
			width: 116px;
			height: 116px;
		}

		.info-right {
			grid-template-columns: 1fr;
			grid-template-rows: auto;
			gap: 6px;
		}

		.device-name {
			font-size: 16px;
			line-height: 24px;
		}

		.info-item {
			height: auto;
			min-height: 34px;
			padding: 6px 10px;
		}

		.tab-container {
			width: 100%;
			align-items: stretch;
			flex-direction: column;
			gap: 10px;
			margin: 0;
		}

		.tab-list {
			width: 100%;
			display: flex;
			align-items: center;
			gap: 6px;
		}

		.tab-item {
			width: 0;
			min-width: 0;
			flex: 1 1 0;
			height: 38px;
			margin-left: 0;
			line-height: 38px;
		}

		.btn-group {
			width: 100%;
			gap: 8px;
			margin-top: 0;
		}

		.operate-btn {
			min-width: 0;
			flex: 1 1 0;
			margin-left: 0 !important;
		}

		.data-card {
			display: grid;
			grid-template-columns: repeat(2, minmax(0, 1fr));
			gap: 8px;
			padding: 8px;
		}

		.data-card::before,
		.data-card::after {
			display: none;
		}

		.data-row {
			display: contents;
		}

		.data-row::before,
		.data-row::after {
			display: none;
			content: none;
		}

		.data-item {
			width: auto;
			height: 104px;
			margin-left: 0;
			padding: 8px;
		}

		.item-header {
			min-width: 0;
			flex-direction: column;
			gap: 1px;
			margin: 0;
		}

		.item-time {
			width: 100%;
			max-width: 100%;
		}

		.item-value {
			margin-top: 8px;
			font-size: 17px;
			line-height: 24px;
			overflow-wrap: anywhere;
		}

		.edit-input {
			width: 100%;
			margin: 8px 0 0;
		}
	}

	@media (max-width: 420px) {
		.info-content {
			flex-direction: column;
		}

		.info-left,
		.device-img-box {
			width: 100% !important;
		}

		.info-left {
			flex-basis: auto;
		}

		.device-img-box {
			height: 140px;
		}

	}
</style>

<style>
	/* 全局公共样式：与系统其他页面统一，抽离复用 */
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
	/* 按钮基础样式 */
	.el-button--primary {
		background-color: var(--solar-primary, #0099FF) !important;
		border-color: var(--solar-border-strong, #0099FF) !important;
		color: var(--solar-text-strong, #FFFFFF) !important;
	}
	.el-button--primary:hover, .el-button--primary:active {
		background-color: var(--solar-primary, #0066CC) !important;
		border-color: var(--solar-border-strong, #0066CC) !important;
	}
	/* 输入框基础样式 */
	.el-input__inner {
		background-color: var(--solar-page, #001A33) !important;
		border: 1px solid var(--solar-border-strong, #0099FF) !important;
		color: var(--solar-text, #87CEFA) !important;
		height: 38px !important;
		line-height: 38px !important;
	}
	.el-input__placeholder {
		color: var(--solar-muted, #6699CC) !important;
	}
</style>
